import { INavigation } from '@/store/modules/personalisation/types';

export const initNavigationData: INavigation = {
  start: 0,
  size: 20,
  direction: 'forward',
  isLastPersoPage: false
};

export default initNavigationData;
